import React from 'react';
import ReactDOM from 'react-dom';
import RestrictedInputMixin from './RestrictedInputMixin';
import {tutils, PropTypes} from 'subschema';

var {noop, returnFirst} = tutils;

export default class RestrictedInput extends RestrictedInputMixin {
    static contextTypes = PropTypes.contextTypes;

    static defaultProps = {
        "onValid": noop,
        "value": ''
    };
    static propTypes = {
        "onValid": PropTypes.validEvent,
        "onChange": PropTypes.valueEvent,
        "formatter": PropTypes.string
    };

    static injectedProps = {
        "value": '.'
    };

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.value !== nextProps.value;
    }

    handleSelectionRange = (caret)=> {
        var input = this.refs && ReactDOM.findDOMNode(this.refs.input);
        if (!input) return;

        if (this.state.value && this.state.caret > -1) {
            input && input.setSelectionRange(this.state.caret, this.state.caret);
        }
    };

    handleValueChange = (e)=> {
        this._value(e.target.value, false);
    };

    render() {
        var {onValid,formatter, onChange, onKeyDown,value, ...props} = this.props;

        var errorId = this.props.id + '-help';

        return <input ref="input"  {...props} value={this.state.value} onKeyDown={this.handleKeyDown}
                      onChange={this.handleValueChange} aria-describedby={errorId} />
    }
}



/** WEBPACK FOOTER **
 ** ./src/types/restrictedInput/RestrictedInput.jsx
 **/